import React, { useCallback, useContext, useMemo, useState } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { isTablet } from 'react-native-device-info';
import { useLayoutSize, useTheme } from '../../theme';
import { iconSize, s, v } from '../../utils/libs';
import CartIcon from '../../components/Reusables/CartIcon';
import SafeAreaWrapper from '../../components/Reusables/SafeAreaWrapper';
import DemoProductList from './components/DemoProductList';
import SearchContext from '../../Context/SearchContext';
interface Props {
  navigation: any;
  onCartCountReport?: (count: number) => void;
}

const DemoProductsScreen: React.FC<Props> = ({
  navigation,
  onCartCountReport,
}) => {
  const { theme } = useTheme();
  const { useSidebarNav } = useLayoutSize();
  const { search, setSearch } = useContext(SearchContext);
  const styles = useMemo(() => createStyles(theme), [theme]);
  const [cartCount, setCartCount] = useState(0);

  const handleCartCountChange = useCallback(
    (count: number) => {
      setCartCount(count);
      onCartCountReport?.(count);
    },
    [onCartCountReport],
  );

  useFocusEffect(
    useCallback(() => {
      setSearch('');
    }, [setSearch]),
  );

  const content = (
    <View style={styles.container}>
      <DemoProductList
        searchQuery={search}
        onCartCountChange={handleCartCountChange}
      />
      {!useSidebarNav && cartCount > 0 ? (
        <View
          style={[
            styles.floatingCart,
            { backgroundColor: theme.colors.success },
          ]}>
          <TouchableOpacity
            activeOpacity={0.9}
            onPress={() => navigation.replace('DemoCart')}>
            <CartIcon
              size={iconSize(isTablet() ? 26 : 22)}
              countOverride={cartCount}
            />
          </TouchableOpacity>
        </View>
      ) : null}
    </View>
  );

  if (useSidebarNav) {
    return content;
  }

  return (
    <SafeAreaWrapper
      edges={['left', 'right']}
      backgroundColor={theme.colors.primaryDark}
      statusBarStyle="light-content">
      {content}
    </SafeAreaWrapper>
  );
};

export default DemoProductsScreen;

const createStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
      backgroundColor: theme.colors.background,
    },
    floatingCart: {
      position: 'absolute',
      height: v(46),
      width: s(46),
      padding: 0,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: v(8),
      elevation: 8,
      right: s(isTablet() ? 10 : 21),
      bottom: v(isTablet() ? 16 : 16),
    },
  });
